const SHOPEE_HOST = /(^|\.)(shopee\.(co\.id|com|sg|com\.my|ph|vn|co\.th|tw|com\.br|cl|com\.mx|com\.co)|shope\.ee)$/i;

// Returns a clickable URL only for real Shopee links; test text returns null.
export const shopeeUrl = (raw) => {
    const s = (raw || "").trim();
    if (!s || /\s/.test(s)) return null;
    try {
        const full = /^https?:\/\//i.test(s) ? s : `https://${s}`;
        return SHOPEE_HOST.test(new URL(full).hostname) ? full : null;
    } catch {
        return null;
    }
};

export const ShopeeLogo = ({ size = 16, className = "" }) => (
    <img src="/shopee-logo.png" alt="Shopee" draggable={false} style={{ height: size, width: "auto" }} className={`inline-block shrink-0 select-none ${className}`} />
);
